import React from 'react';
import { graphql } from 'gatsby';
import Layout from 'components/layout';
import SEO from 'react-seo-component';
import Hero from '../components/hero';
import Pill from '../vectors/pill';
import Fade from 'react-reveal/Fade';
import DotGrid from '../images/dot-grid.png';
import DotGridPurple from "../images/dot-grid-purple.png";
import Collage from "../images/collage.png"

function AboutUs(props) {
  const data = props.data.prismic.allAbout_uss.edges[0].node;
  const social = props.data.prismic.allSocials.edges.slice(0, 1).pop();

  return (
    <Layout>
      <SEO
        title="About"
        titleTemplate={social.node.default_title || "eScript360"}
        description={
          social.node.default_description ||
          'No copays, deductibles, prior authorizations, or pre-approvals. Welcome to Pharmacy Redefined.'
        }
        image={'src/images/eScript.logo.png'}
        pathname="https://www.escript360.com/about-us"
        siteLanguage="en-US"
        siteLocale="en_us"
        twitterUsername="@escript360"
      />

      <Hero heading={"An end-to-end solution"} svg={true} />

      {/* about introduction */}
      <div className="intro">
        <div className="intro__inner">
          <div className="intro__floaters">
            <Fade bottom distance="4rem">
              <div className="floater">
                <Pill fill="#00B4D7" />
              </div>
              <div className="floater">
                <Pill fill="#00B4D7" />
              </div>
              <div className="floater">
                <Pill fill="#00B4D7" />
              </div>
              <div className="floater">
                <Pill fill="#00B4D7" className="circular" />
              </div>
              <div className="floater">
                <Pill fill="#00B4D7" className="circular" />
              </div>
            </Fade>
          </div>

          <h2 className="intro__heading">eScript360 is the gateway to care and your brand.</h2>
          <div className="intro__text">
            <b>An end-to-end solution</b>, supporting patients throughout their journey of care while serving manufacturers of biopharmaceuticals and other clinical products with patient access solutions to therapy for all disease states. Empowered with expertise, digital assets, and an individualized perspective and approach to treatment, we offer the essentials to remove obstacles, efficiencies to expedite care, and a better patient experience to deliver comprehensive therapy.
            <br /><br />
            <b>The eS workflow model</b> was conceived and developed by veteran healthcare professionals. The collaborative journey of care is based on the best practice for positive outcomes:
          </div>
        </div>
      </div>


      <div className="elevator-pitch">
        <div className="elevator-pitch__inner">
          <ul className="fact-list">
            <li>
              <div className="fact-list__icon">
                <div className="fact-list__image">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128"><path fill="#4b328c" d="M79.9 83.8C74.8 82 69.5 81 64 81c0 0 0 0 0 0s0 0 0 0c-16.4 0-31.6 8.9-39.7 23.1-.8 1.4-.3 3.3 1.1 4.1.5.3 1 .4 1.5.4 1 0 2.1-.5 2.6-1.5C36.6 94.7 49.8 87 64 87c0 0 0 0 0 0s0 0 0 0c4.7 0 9.4.8 13.8 2.5.3.1.7.2 1 .2 1.2 0 2.4-.7 2.8-2C82.2 86.1 81.4 84.4 79.9 83.8zM64 27c-12.7 0-23 10.3-23 23s10.3 23 23 23 23-10.3 23-23S76.7 27 64 27zM64 67c-9.4 0-17-7.6-17-17s7.6-17 17-17 17 7.6 17 17S73.4 67 64 67zM121.9 97.6c-.5.5-1 1.1-1.6 1.8-4.4 5-12 13.5-12 13.5-.6.6-1.4 1-2.2 1 0 0 0 0-.1 0-.9 0-1.7-.4-2.3-1.2l-6.9-8.9c-.9-1.1-.9-2.8 0-3.9 1.3-1.5 3.5-1.4 4.6.1l4.8 6.2c0 0 7.3-8.2 11.1-12.5.3-.4.6-.7.9-1 .8-.9.7-2.2-.3-2.9-3.7-2.7-8.3-4.2-13.2-3.9-10 .7-18.2 8.9-18.6 19-.6 11.8 9.1 21.5 21 20.9 10-.5 18.2-8.5 19-18.4.3-3.4-.3-6.7-1.6-9.6C123.9 97 122.6 96.8 121.9 97.6z"></path></svg>
                </div>
              </div>
              <h3 className="fact-list__heading">
                Provide quality care
              </h3>
            </li>
            <li>
              <div className="fact-list__icon">
                <div className="fact-list__image">
                  <svg xmlns="http://www.w3.org/2000/svg" width="90px" viewBox="0 0 50 50"><path fill="#4b328c" d="M 14.130859 4 C 6.3388594 4 0 10.367359 0 18.193359 C 0 19.519359 0.12751563 20.785 0.35351562 22 L 2.4003906 22 C 2.1443906 20.787 2 19.521359 2 18.193359 C 2 11.470359 7.4408594 6 14.130859 6 C 17.820859 6 20.949687 7.5625781 23.429688 10.642578 C 23.621688 10.882578 24.189453 11.613281 24.189453 11.613281 C 24.568453 12.101281 25.390531 12.101281 25.769531 11.613281 C 25.769531 11.612281 26.334297 10.885531 26.529297 10.644531 C 28.973297 7.6055313 32.203141 6 35.869141 6 C 42.559141 6 48 11.470359 48 18.193359 C 48 29.792359 37.458719 36.881641 29.761719 42.056641 C 27.955719 43.270641 26.322094 44.595219 24.996094 45.699219 C 23.937094 44.829219 21.801328 43.106687 20.236328 42.054688 C 14.996328 38.530687 8.4401094 34.118 4.7871094 28 L 2.46875 28 C 6.18775 35.011 13.400094 39.868797 19.121094 43.716797 C 21.145094 45.076797 24.325422 47.738625 24.357422 47.765625 C 24.529422 47.910625 24.750609 47.978516 24.974609 47.978516 C 25.233609 47.978516 25.496266 47.887703 25.697266 47.720703 C 27.030266 46.604703 28.856953 45.074797 30.876953 43.716797 C 38.947953 38.288797 50 30.857359 50 18.193359 C 50 10.367359 43.661141 4 35.869141 4 C 31.580141 4 27.814516 5.8608594 24.978516 9.3808594 C 22.143516 5.8608594 18.391859 4 14.130859 4 z M 17.490234 11 A 1.0001 1.0001 0 0 0 16.521484 11.798828 L 13.720703 25.40625 L 11.935547 20.648438 A 1.0001 1.0001 0 0 0 10.105469 20.552734 L 8.3828125 24 L 2 24 A 1.0001 1.0001 0 1 0 2 26 L 9 26 A 1.0001 1.0001 0 0 0 9.8945312 25.447266 L 10.869141 23.498047 L 13.064453 29.351562 A 1.0001 1.0001 0 0 0 14.978516 29.201172 L 17.4375 17.253906 L 20.515625 34.179688 A 1.0001 1.0001 0 0 0 22.433594 34.359375 L 26.488281 23.816406 L 28.564453 29.351562 A 1.0001 1.0001 0 0 0 30.347656 29.529297 L 32.554688 26 L 37.271484 26 A 2 2 0 0 0 39 27 A 2 2 0 0 0 41 25 A 2 2 0 0 0 39 23 A 2 2 0 0 0 37.269531 24 L 32 24 A 1.0001 1.0001 0 0 0 31.152344 24.470703 L 29.724609 26.753906 L 27.435547 20.648438 A 1.0001 1.0001 0 0 0 25.566406 20.640625 L 21.845703 30.3125 L 18.484375 11.820312 A 1.0001 1.0001 0 0 0 17.490234 11 z"></path></svg>
                </div>
              </div>
              <h3 className="fact-list__heading">
                Treat patients with dignity and respect
              </h3>
            </li>
            <li>
              <div className="fact-list__icon">
                <div className="fact-list__image">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path fill="#4b328c" d="M457,60.1H200.433a40.045,40.045,0,0,0-40,40v25.7H55a40.045,40.045,0,0,0-40,40v181a40.045,40.045,0,0,0,40,40H66.811V441.9a10,10,0,0,0,15.421,8.4L180.664,386.8H283.783a40.045,40.045,0,0,0,40-40V315.123H338.1L430.948,390.9a10,10,0,0,0,16.323-7.748V315.123H457a40.045,40.045,0,0,0,40-40V100.1A40.045,40.045,0,0,0,457,60.1ZM303.784,346.8a20.023,20.023,0,0,1-20,20H177.719a10,10,0,0,0-5.421,1.6L86.812,423.552V376.8a10,10,0,0,0-10-10H55a20.023,20.023,0,0,1-20-20v-181a20.023,20.023,0,0,1,20-20H160.433V275.123a40.045,40.045,0,0,0,40,40H303.784ZM477,275.123a20.023,20.023,0,0,1-20,20H437.271a10,10,0,0,0-10,10v56.961l-79.29-64.708a10,10,0,0,0-6.323-2.252H200.433a20.023,20.023,0,0,1-20-20V100.1a20.023,20.023,0,0,1,20-20H457a20.023,20.023,0,0,1,20,20Z"></path>
                  </svg>
                </div>
              </div>
              <h3 className="fact-list__heading">
                Respond to their needs
              </h3>
            </li>
          </ul>
        </div>
      </div>

      {/* advisors */}
      <div className="advisors">
        <div className="advisors__inner">
          <header className="advisors__header">
            <div className="advisors__bracers">
              <Fade left distance="4rem">
                <div className="floater">
                  <img src={DotGrid} alt="" />
                </div>
              </Fade>

              <Fade right distance="4rem">
                <div className="floater">
                  <img src={DotGrid} alt="" />
                </div>
              </Fade>
            </div>

            {/* <h2 className="advisors__heading">{data.advisors_heading.text}</h2> */}
            <p className="advisors__text">{data.advisors_text[0].text}</p>
          </header>

          <ul className="advisors__members">
            {data.advisors_list.map((advisor, index) => {
              return (
                <li key={index}>
                  <h3 className="advisors__name">{advisor.name}</h3>
                  <h4 className="advisors__title">{advisor.title}</h4>
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      <div className="homepage-hero">
        <div className="homepage-hero__inner">
          <div className="homepage-hero__content">
            <div className="homepage-hero__heading">
              Let's work together
            </div>
            <div className="homepage-hero__text">
              Beginning with the patient and their introduction to your brand, to their referral for treatment and their connection with the physician or pharmacy – but it doesn’t end there. The patient experience continues with the ongoing coordination of support and care provided by our dedicated clinical care team of physicians, nurses, PAs, clinical pharmacists, social workers, and other health professionals.
              <br />
              <br />
              eScript360 is your partner in delivering medication treatment by <b>clearing a pathway</b> for care that reaches everyone.
            </div>
            <div className="homepage-hero__cta">
              <button onClick={() => window.location.href = "/join-us#contact"} className="button button--secondary">
                Get in Touch
              </button>
            </div>
          </div>

          <div className="homepage-hero__image-container">
            <Pill fill="#00B4D7" className='first_pill' />
            <Pill fill="#00B4D7" className='second_pill' />
            <img
              src={Collage}
              alt=""
              className="homepage-hero__image"
            />

            <Fade right distance="4rem">
              <img
                src={DotGridPurple}
                alt=""
                className="homepage-hero__dot-grid"
              />
            </Fade>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default AboutUs;

export const query = graphql`
  {
    prismic {
      allAbout_uss {
        edges {
          node {
            advisors_text
            advisors_list {
              name
              title
            }
            join_button_url {
              ... on PRISMIC_Med_finder {
                _meta {
                  uid
                }
              }
            }
          }
        }
      }
      allSocials {
        edges {
          node {
            default_description
            default_title
          }
        }
      }
    }
  }
`;
